import { Text } from "components/commons";
import { dateTimeFormat, formatAmount, formatVolume } from "utils";
import { prettifyAdjustmentType, prettifyPaymentMethod } from "utils/pretty.utils";
import styles from "../cash-noncash.module.scss";
import { calculateTotalizerVariance } from "../../shift-details-utils";
import Big from "big.js";

export const varianceAdjustmentMapper = ({ shiftDiscounts, val, employee }) => {
  const {
    transaction,
    name,
    pump,
    beginningTotalizer,
    endingTotalizer,
    quantity,
    grossTotalAmount,
    totalPumpDiscount,
  } = val;

  // const totalPumpDiscount = pumpDiscount * quantity;

  const finalAmount = Number(Big(grossTotalAmount).minus(totalPumpDiscount));

  const { isNegative } = calculateTotalizerVariance(beginningTotalizer, endingTotalizer, quantity);

  return {
    adjustmentType: (
      <>
        <Text className={styles.content}>
          {prettifyAdjustmentType(transaction.adjustmentType ?? "")}
        </Text>
      </>
    ),
    productPumpNumber: (
      <>
        <Text className={styles.content}>{name}</Text>
        <Text className={styles.subtitle}>{pump}</Text>
      </>
    ),
    quantity: (
      <>
        <Text className={!isNegative ? styles.content : styles.negative}>
          {!isNegative ? formatVolume(Math.abs(quantity)) : `- ${formatVolume(Math.abs(quantity))}`}
        </Text>
      </>
    ),
    amount: (
      <>
        <Text className={!isNegative ? styles.content : styles.negative}>
          {!isNegative
            ? formatAmount(Math.abs(grossTotalAmount))
            : `- ${formatAmount(Math.abs(grossTotalAmount))}`}
        </Text>
      </>
    ),
    discount: (
      <>
        {Math.abs(totalPumpDiscount) > 0 ? (
          <Text className={isNegative ? styles.content : styles.negative}>
            {isNegative
              ? formatAmount(Math.abs(totalPumpDiscount) ?? 0)
              : `- ${formatAmount(Math.abs(totalPumpDiscount) ?? 0)}`}
          </Text>
        ) : (
          <Text className={styles.content}>{formatAmount(Math.abs(totalPumpDiscount) ?? 0)}</Text>
        )}
      </>
    ),
    finalAmountPaid: (
      <>
        <Text className={!isNegative ? styles.content : styles.negative}>
          {!isNegative
            ? formatAmount(Math.abs(finalAmount))
            : `- ${formatAmount(Math.abs(finalAmount))}`}
        </Text>
      </>
    ),
    paymentMethodRefNo: (
      <>
        <Text className={styles.content}>
          {prettifyPaymentMethod(transaction.paymentMethods[0].method ?? "")}
        </Text>
        <Text className={styles.subtitle}>{transaction.paymentMethods[0].refNumber}</Text>
      </>
    ),
    createdByDateTime: (
      <>
        <Text className={styles.content}>{employee}</Text>
        <Text className={styles.subtitle}>{dateTimeFormat(transaction.processedAt)}</Text>
      </>
    ),
  };
};
